<template lang="pug">
.search-bar
  form.flex.flex-nowrap.gap-2.text-base.sm_text-sm(@submit.prevent="onSearch" data-testid="search-bar-form")
    .input-container.flex.flex-nowrap.bg-gray-50.rounded-md.px-4.py-2.w-64
      .flex.items-center.w-0.overflow-visible.whitespace-nowrap.text-gray-500(v-show="!searchQuery")
        MagnifyingGlassIcon.w-4.h-4.flex-shrink-0
        span.ml-1 {{ placeholder }}
      input.bg-transparent.outline-none.border-none.w-full.p-0.focus_outline-none.focus_ring-0(
        type="text"
        v-model="searchQuery"
        @input="e => (searchQuery = e.target.value)"
        v-analytics="`${analyticsEventNamePrefix}SearchSelected`"
        data-testid="search-bar-input"
      )

      XMarkIcon.h-5.w-5(@click="clearSearchQuery" v-show="searchQuery")

    VButton.v-btn-copper(size="sm" type="submit") Search
</template>

<script lang="ts" setup>
import type { Ref } from 'vue'
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/vue/24/solid'

const props = defineProps({
  searchPlaceholder: {
    type: String,
    required: true,
  },
  previousSearchQuery: {
    type: String,
    default: '',
    required: false,
  },
  analyticsEventNamePrefix: {
    type: String,
    default: '',
    required: false,
  },
})

const emit = defineEmits(['on-search', 'clear-previous-search-query'])
const searchQuery: Ref<string> = ref('')
const placeholder = computed(() => `Search ${props.searchPlaceholder}`)

onMounted(() => {
  if (props.previousSearchQuery) {
    searchQuery.value = props.previousSearchQuery
  }
})

const clearSearchQuery = () => {
  searchQuery.value = ''
  emit('clear-previous-search-query')
  onSearch()
}

watch(
  () => props.previousSearchQuery,
  q => (searchQuery.value = q)
)

const onSearch = () => {
  emit('on-search', searchQuery.value)
}
</script>
